import { Grid, Typography } from '@mui/material';
import { memo } from 'react';

import {
  convertCeilingType,
  convertFacadeFinish,
  convertMainFacadeMaterial,
  convertRoofType,
} from '../../../api/characteristics/enumerations';
import {
  HouseFramesAndFacades,
  SectionStatus,
} from '../../../api/characteristics/types';
import { SectionStatusBadge } from '../components/StatusIndicators';
import { AnswerTag, AnswerTagsBox, StyledDivider } from '../styles';

interface HouseFramesAndFacadesSectionProps {
  formData: HouseFramesAndFacades;
  sectionStatus?: SectionStatus;
}

export const HouseFramesAndFacadesSection = memo(
  function HouseFramesAndFacadesSection({
    formData,
    sectionStatus,
  }: HouseFramesAndFacadesSectionProps) {
    return (
      <Grid container spacing={2} marginBottom={3}>
        <Grid item xs={12}>
          <SectionStatusBadge status={sectionStatus} />
        </Grid>
        <Grid item xs={12}>
          <Typography
            fontSize={18}
            fontWeight={600}
            id="frames-fachada-principal"
          >
            Fachada Principal
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography fontWeight={600}>Esquadrias</Typography>
        </Grid>
        <Grid item xs={12}>
          <AnswerTagsBox>
            {formData.main_facade.frames.length > 0 ? (
              formData.main_facade.frames.map((v) => (
                <AnswerTag key={v}>{convertMainFacadeMaterial(v)}</AnswerTag>
              ))
            ) : (
              <Typography>-</Typography>
            )}
            {formData.main_facade.frames_other && (
              <AnswerTag>{formData.main_facade.frames_other}</AnswerTag>
            )}
          </AnswerTagsBox>
        </Grid>
        <Grid item xs={12}>
          <Typography fontWeight={600}>Revestimento</Typography>
        </Grid>
        <Grid item xs={12}>
          <AnswerTagsBox>
            {formData.main_facade.finishes.length > 0 ? (
              formData.main_facade.finishes.map((v) => (
                <AnswerTag key={v}>{convertFacadeFinish(v)}</AnswerTag>
              ))
            ) : (
              <Typography>-</Typography>
            )}
            {formData.main_facade.finishes_other && (
              <AnswerTag>{formData.main_facade.finishes_other}</AnswerTag>
            )}
          </AnswerTagsBox>
        </Grid>
        <Grid item xs={12}>
          <StyledDivider />
        </Grid>
        <Grid item xs={12}>
          <Typography
            fontSize={18}
            fontWeight={600}
            id="frames-demais-fachadas"
          >
            Demais Fachadas
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography fontWeight={600}>Esquadrias</Typography>
        </Grid>
        <Grid item xs={12}>
          <AnswerTagsBox>
            {formData.other_facades.frames.length > 0 ? (
              formData.other_facades.frames.map((v) => (
                <AnswerTag key={v}>{convertMainFacadeMaterial(v)}</AnswerTag>
              ))
            ) : (
              <Typography>-</Typography>
            )}
            {formData.other_facades.frames_other && (
              <AnswerTag>{formData.other_facades.frames_other}</AnswerTag>
            )}
          </AnswerTagsBox>
        </Grid>
        <Grid item xs={12}>
          <Typography fontWeight={600}>Revestimento</Typography>
        </Grid>
        <Grid item xs={12}>
          <AnswerTagsBox>
            {formData.other_facades.finishes.length > 0 ? (
              formData.other_facades.finishes.map((v) => (
                <AnswerTag key={v}>{convertFacadeFinish(v)}</AnswerTag>
              ))
            ) : (
              <Typography>-</Typography>
            )}
            {formData.other_facades.finishes_other && (
              <AnswerTag>{formData.other_facades.finishes_other}</AnswerTag>
            )}
          </AnswerTagsBox>
        </Grid>
        <Grid item xs={12}>
          <StyledDivider />
        </Grid>
        <Grid item xs={12}>
          <Typography fontSize={18} fontWeight={600} id="frames-teto">
            Teto / Forro
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography fontWeight={600}>Material</Typography>
        </Grid>
        <Grid item xs={12}>
          <AnswerTagsBox>
            {formData.ceiling.materials.length > 0 ? (
              formData.ceiling.materials.map((v) => (
                <AnswerTag key={v}>{convertCeilingType(v)}</AnswerTag>
              ))
            ) : (
              <Typography>-</Typography>
            )}
            {formData.ceiling.materials_other && (
              <AnswerTag>{formData.ceiling.materials_other}</AnswerTag>
            )}
          </AnswerTagsBox>
        </Grid>
        <Grid item xs={12}>
          <StyledDivider />
        </Grid>
        <Grid item xs={12}>
          <Typography fontSize={18} fontWeight={600} id="frames-cobertura">
            Cobertura
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography fontWeight={600}>Material</Typography>
        </Grid>
        <Grid item xs={12}>
          <AnswerTagsBox>
            {formData.roof.materials.length > 0 ? (
              formData.roof.materials.map((v) => (
                <AnswerTag key={v}>{convertRoofType(v)}</AnswerTag>
              ))
            ) : (
              <Typography>-</Typography>
            )}
            {formData.roof.materials_other && (
              <AnswerTag>{formData.roof.materials_other}</AnswerTag>
            )}
          </AnswerTagsBox>
        </Grid>
      </Grid>
    );
  }
);
